import { apiGet, apiPut } from "./client";

export interface UserPreferences {
  date_system: string;
  round_precision: number;
  number_formatting_locale: string;
  chart_primary_color: string | null;
}

export interface UserPreferencesPayload {
  dateSystem: string;
  roundPrecision: number;
  numberFormattingLocale: string;
  chartPrimaryColor: string | null;
}

export function getUserPreferences(): Promise<UserPreferences> {
  return apiGet<UserPreferences>("/user/preferences");
}

export function putUserPreferences(
  payload: UserPreferencesPayload,
): Promise<void> {
  return apiPut<void>("/user/preferences", {
    date_system: payload.dateSystem,
    round_precision: payload.roundPrecision,
    number_formatting_locale: payload.numberFormattingLocale,
    chart_primary_color: payload.chartPrimaryColor,
  });
}
